import { useState } from 'react';

const CategoryFilter = ({ 
  title, 
  isOpen, 
  toggleFilter, 
  items = [], 
  selectedItems = [],
  onSelectionChange,
  colorMap = {}, 
  showSearch = false,
  itemCounts = {} // Object mapping item names to counts
}) => {
  const [searchTerm, setSearchTerm] = useState('');
  
  // Filter items based on search term
  const filteredItems = items.filter(item => 
    item.toLowerCase().includes(searchTerm.toLowerCase())
  );
  
  // Capitalize the first letter of each word
  const capitalizeWords = (str) => {
    return str
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  // Handle checkbox change
  const handleCheckboxChange = (item, isChecked) => {
    if (isChecked) {
      // Add item to selected items
      onSelectionChange([...selectedItems, item]);
    } else {
      // Remove item from selected items
      onSelectionChange(selectedItems.filter(selectedItem => selectedItem !== item));
    }
  };

  return (
    <div className="mb-4 filter-section">
      <button 
        className="flex w-full justify-between p-0 h-auto mb-2 hover:bg-transparent filter-toggle"
        onClick={toggleFilter}
      >
        <h3 className="font-medium text-cream tracking-wider uppercase text-sm">
          {title} {selectedItems.length > 0 && `(${selectedItems.length})`}
        </h3>
        <svg 
          xmlns="http://www.w3.org/2000/svg" 
          width="20" height="20" 
          viewBox="0 0 24 24" 
          fill="none" 
          stroke="currentColor" 
          strokeWidth="2" 
          strokeLinecap="round" 
          strokeLinejoin="round" 
          className={`h-5 w-5 transition-transform text-purple transform ${isOpen ? 'rotate-180' : ''}`}
        >
          <path d="m6 9 6 6 6-6"/>
        </svg>
      </button>
      <div className={`filter-content space-y-2 pl-1 ${!isOpen ? 'hidden' : ''}`}>
        {/* Search input for filters with many options */}
        {showSearch && (
          <div className="relative mb-2">
            <input 
              type="text" 
              placeholder={`Search ${title.toLowerCase()}...`}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full h-9 rounded-md border border-purple/30 bg-dark/50 px-3 py-1 text-sm text-cream placeholder:text-cream/50"
            />
          </div>
        )}
        
        {/* Show filter items */}
        {filteredItems.length > 0 ? (
          filteredItems.map((item, index) => (
            <div key={index} className="flex items-center space-x-2">
              <input 
                type="checkbox" 
                id={`${title.toLowerCase()}-${item}`} 
                className="border-purple/50 rounded h-4 w-4"
                checked={selectedItems.includes(item)}
                onChange={(e) => handleCheckboxChange(item, e.target.checked)}
              />
              {colorMap && colorMap[item] && (
                <div className={`h-3 w-3 rounded-full ${colorMap[item]}`}></div>
              )}
              <label 
                htmlFor={`${title.toLowerCase()}-${item}`} 
                className="text-sm cursor-pointer tracking-wide text-cream/80"
              >
                {capitalizeWords(item)}
                {itemCounts[item] !== undefined && itemCounts[item] > 0 && (
                  <span className="ml-1 text-cream/60">({itemCounts[item]})</span>
                )}
              </label>
            </div>
          ))
        ) : (
          <p className="text-xs text-cream/50">No {title.toLowerCase()} available</p>
        )}
        
        {/* Clear selection button */}
        {selectedItems.length > 0 && (
          <button 
            onClick={() => onSelectionChange([])}
            className="text-xs text-skyblue p-0 h-auto tracking-wide mt-2"
          >
            CLEAR SELECTION
          </button>
        )}
      </div>
    </div>
  );
};

export default CategoryFilter;